enum CIRCLE_BUTTON_BACKGROUNDS {
    GREEN = 'GREEN',
    GRADIENT = 'GRADIENT',
}

export { CIRCLE_BUTTON_BACKGROUNDS };
